module.exports = __webpack_public_path__ + "media/contact/Group 322-110df371.png";